"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildShareButtonComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _shapes = require("./shapes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var buildShareButtonComponent = function buildShareButtonComponent(_ref) {
  var action = _ref.action,
      ariaLabel = _ref.ariaLabel,
      buttonLabel = _ref.buttonLabel,
      className = _ref.className,
      icon = _ref.icon;

  var ShareButton = function ShareButton(props) {
    var Shape = _shapes.shapes[props.shape];

    var handleClick = function handleClick(event) {
      event.preventDefault();
      props.beforeOnClick && props.beforeOnClick(event);
      action(props);
    };

    return /*#__PURE__*/_react["default"].createElement(Shape, {
      "aria-label": ariaLabel,
      boxShadow: props.boxShadow,
      className: props.className || '',
      buttonClassName: className,
      href: "#",
      onClick: handleClick,
      role: "button",
      title: props.title || '',
      label: buttonLabel || ariaLabel,
      icon: icon,
      content: props.content
    });
  }; // eslint-disable-next-line @typescript-eslint/no-explicit-any


  return ShareButton;
};

exports.buildShareButtonComponent = buildShareButtonComponent;